<template>
  <p>Oturum yetkilendiriliyor...</p>
</template>

<script>
/* eslint-disable */
import axios from 'axios'

export default {
  name: 'CallbackPage',
  data() {
    return {
      token: '',
    }
  },
  methods: {
    parseQueryString() {
      var search = location.search.substring(1);
      var qos = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value) })
      console.log('---- qos ----');
      console.log(qos);

      let dataEncoded = new URLSearchParams();
      dataEncoded.append('grant_type', 'authorization_code');
      dataEncoded.append('code_verifier', localStorage.getItem(qos.state));
      dataEncoded.append('redirect_uri', 'http://localhost:8080/callback');
      dataEncoded.append('code', qos.code);
      dataEncoded.append('client_id', 'spa');
      dataEncoded.append('scope', 'api1');

      axios.request({
        url: "/connect/token",
        method: "post",
        baseURL: "https://localhost:5001/",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: dataEncoded
      }).then(res => {
        this.$store.dispatch('setAuthStatus', true)        
        axios.defaults.headers.common = { 'Authorization': 'Bearer ' + res.data.access_token }
        this.$router.push('/')
      })
      .catch(err => { console.log(err) })

      localStorage.removeItem(qos.state)
      qos = null
    }
  },
  mounted() {
    if(!this.$store.getters.isAuthenticated)
      this.parseQueryString()
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CallbackPage.vue